import { getValidationsData, mergeValidationData, moveValidationOption } from "./api/validation.api";

const getValidations = async (data) => {
    try {
        const res = await getValidationsData(data);
        return res;
    } catch (e) {
        // Error handled silently
    }
};

const mergeValidation = async (data) => {
    try {
        const res = await mergeValidationData(data);
        return res;
    } catch (e) {
        // Error handled silently
    }
};

const moveValidationOptionApi = async (data) => {
    try {
        const res = await moveValidationOption(data);
        return res;
    } catch (e) {
        // Error handled silently
    }
};

export {
    getValidations,
    mergeValidation,
    moveValidationOptionApi
}
